<template>
    <div class="plan">
        <div class="plan_card_container mb-15 white-box">
                <div class = "investmentContainer">
                    <span class="earn_text">Earn upto</span>
                    <span class = "investmentValue">Invested: &#x20B9;{{ getInvestmentAmount | localeAmountPaisa}}</span>
                </div>
                <span class = "planPercentageText">{{planPercentage}}%
                    <span class="perAnnumnText">per annum</span>
                </span>
                <span class = "planTypeText">{{portfolio.planType}} {{portfolio.riskProfile}}</span>
                <span class = "tenure_text">Lock-in 12 Months</span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PlanCardNew',
    props: {
        portfolio: Object
    },
    computed: {
        getInvestmentAmount () {
            const investment = this.portfolio.investmentAmount + (this.portfolio.pendingInvestmentAmount || 0)
            return investment
        },
        planPercentage () {
            let percentage = 0
            if (this.portfolio.planType === 'growth' && this.portfolio.riskProfile === 'aggressive') {
                percentage = 18
            } else if (this.portfolio.planType === 'growth' && this.portfolio.riskProfile === 'conservative') {
                percentage = 14
            } else if (this.portfolio.planType === 'income' && this.portfolio.riskProfile === 'aggressive') {
                percentage = 16
            } else if (this.portfolio.planType === 'income' && this.portfolio.riskProfile === 'conservative') {
                percentage = 12
            }
            return percentage
        }
    }
}
</script>
<style lang="scss" scoped>

.active {
    background-color: #0c0c2d !important;
    .earn_text, .investmentValue, .planPercentageText, .perAnnumnText, .planTypeText, .tenure_text{
        color: #ffffff
    }
}
.investmentValue {
    color: #4f4f4f;
    font-size: 13px;
    width: -webkit-fill-available;
    text-align: right;
    padding-right: 15px;
}
.investmentContainer {
    display: flex;
    flex-direction: row;
}
.white-box {
    background-color: #fff8e7;
    border: 0px solid #E5E5E5;
    cursor: default;
    padding-left: 24px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 0px
}
.plan_card_container {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: 320px;
}
.tenure_text {
    font-weight: 400;
    font-size: 12px;
    color: #8C8C8C;
}

.earn_text {
    width: 100%;
    font-size: 14px;
    color: #9e9e9e;
    font-weight: 500
}

.planPercentageText {
    font-size: 28px;
    color: #002fa7;
    font-weight: 700
}

.perAnnumnText {
    font-size: 12px;
    color: #232323;
    font-weight: 400;
    padding-left: 1px
}

.planTypeText {
    text-transform: capitalize;
    font-size: 17px;
    color: #232323;
    font-weight: 800
}
.tenureContainer {
    padding-bottom: 0px;
}

.planLine {
    width: 100%;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    line-height: 0.1em;
    margin: 10px 0 20px;
}

.planText {
    background: #fff;
    padding: 0 10px;
    font-weight: 500;
    font-size: 18px;
    color: #9e9e9e;
}

@media (max-width: 480px) {
    .plan_card_container {
        width: 300px;
    }
}
</style>
